import { BudgetPhases } from 'business/constants';
import {
    PRIMITIVE_BUDGET,
    PRIMITIVE_BUDGET_AMOUNT,
    PRIMITIVE_BUDGET_COMMENT,
    PRIMITIVE_BUDGET_ID,
    PRIMITIVE_BUDGET_STATUS,
} from 'routes/BudgetModule/config/constants';
import { PhaseHelpers } from '../phase';

const voteConstants = {
    status: PRIMITIVE_BUDGET_STATUS,
    inProgressStatus: undefined as undefined,
    toValidateStatus: undefined as undefined,
    doneStatus: undefined as undefined,
    comment: PRIMITIVE_BUDGET_COMMENT,
    amount: PRIMITIVE_BUDGET_AMOUNT,
    id: PRIMITIVE_BUDGET_ID,
    table: PRIMITIVE_BUDGET,
    isEditable: false,
    isActive: true,
    isSimulated: false,
    endpoint: undefined as undefined,
    name: BudgetPhases.VOTE,
} as const;

const voteHelpers: PhaseHelpers = {
    getPhaseHeaderName: (exercice, t) =>
        t
            ? t('budgetProposal.primitiveBudgetVotedYear', {
                  year: exercice,
              })
            : '',
} as const;

export const votePhase = {
    ...voteConstants,
    ...voteHelpers,
} as const;
